import React, {FC} from 'react';

import {Handler, HandlerOf} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ReplyTypesEnum, VisualRecipientMap} from '../../../../../../helpers/models/recipientHelpers';
import {ChannelModel} from '../../../../../../models/api/channelModel';
import {LoadedMessageModel} from '../../../../../../models/api/messageModel';
import {ReplyLocationsEnum} from '../../../../../../services/tracking';
import {EmlPanelId, MessagePanelId, ViewerPanelId} from '../../../../../../store/panels/panelStateBase';
import {TimelineVariationsEnum} from '../../../../../../store/timelineVariations/timelineVariationSelectors';
import {AnnotationsHighlightViewerInheritableProps} from '../../../../../common/annotation/annotationsHighlightViewer';
import {MessageViewerAttachmentsContainer} from '../messageViewerAttachmentsContainer';
import {MessageViewerFullHeader, MessageViewerFullHeaderProps} from '../messageViewerFullHeader';
import {MessageViewerEmailActionsContainer} from './messageViewerEmailActionsContainer';
import {MessageViewerEmailBodyContainer} from './messageViewerEmailBodyContainer';
import {MessageViewerEmailFullHeaderDragSource} from './messageViewerEmailFullHeaderDragSource';

/*
 * Props.
 */

interface MessageViewerEmailProps
  extends MessageViewerFullHeaderProps,
    AnnotationsHighlightViewerInheritableProps {
  panelId: ViewerPanelId | MessagePanelId | EmlPanelId;
  message: LoadedMessageModel;
  visualRecipients: VisualRecipientMap;
  replyChannel?: ChannelModel;
  defaultReplyType: ReplyTypesEnum;
  onReplyClick: HandlerOf<ReplyLocationsEnum>;
  onReplyAllClick: HandlerOf<ReplyLocationsEnum>;
  onOpenMessageRenderClick: Handler;
  onPopoutClick: Handler;
  isExternalContentHidden: boolean;
  isUserVisitor: boolean;
  isInMessagePopup: boolean;
}

/*
 * Component.
 */

export const MessageViewerEmail: FC<MessageViewerEmailProps> = ({replyChannel, ...props}) => (
  <>
    {renderHeader(props)}
    <MessageViewerAttachmentsContainer
      message={props.message}
      timelineVariation={TimelineVariationsEnum.ASYNCHRONOUS}
    />
    <MessageViewerEmailBodyContainer {...props} />
    {replyChannel && <MessageViewerEmailActionsContainer {...props} replyChannel={replyChannel} />}
  </>
);

function renderHeader(props: MessageViewerEmailProps) {
  return (
    <MessageViewerEmailFullHeaderDragSource message={props.message}>
      <MessageViewerFullHeader isInDragRegion {...props} />
    </MessageViewerEmailFullHeaderDragSource>
  );
}
